import { Link } from 'react-router-dom';

export function ReturnsAnalyticsPage() {
  return (
    <div className="mx-auto max-w-6xl p-6">
      <Link to="/returns" className="text-sm text-slate-600 hover:underline">← Returns hub</Link>
      <h1 className="mt-2 text-2xl font-semibold">Return analytics</h1>
      <p className="mt-2 text-sm text-slate-600">
        Reason clustering, fraud risk scores, and return cost analysis are available via the returns intelligence API.
      </p>
    </div>
  );
}
